export const splitToFirstAndLastName = (value: string): { firstName: string; lastName: string } => {
  if (!value) {
    return { firstName: '', lastName: '' };
  }
  const words: string[] = value.split(' ');
  return {
    firstName: words[0],
    lastName: words.slice(1).join(' '),
  };
};
